// AIDEV-NOTE: Utilities for operations formatting and validation

/**
 * Formatar nomes próprios com capitalização correta
 */
export const formatNome = (name) => {
  if (!name) return "";
  let lowerCaseName = name.toLowerCase();
  let properName = lowerCaseName.replace(
    /(^|\s|')(\w)/g,
    function (match, separator, letter, index, fullText) {
      const matchResult = fullText.slice(index).match(/^[^\s']+|\b\w+/);
      if (!matchResult) {
        return match;
      }
      const word = matchResult[0];
      const lowerCaseWords = ["de", "da", "do", "dos", "das"];
      if (lowerCaseWords.includes(word)) {
        return separator + letter;
      }
      return separator + letter.toUpperCase();
    }
  );
  return properName;
};

/**
 * Formatar valores em BRL com padrão brasileiro
 */
export const formatCurrency = (value) => {
  if (!value || isNaN(value)) {
    return "R$ 0,00";
  }
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};

/**
 * Formatar valores crypto com 6 decimais e moeda
 */
export const formatCrypto = (value, moeda) => {
  if (!value || !moeda) {
    return "0,000000";
  }
  return `${parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 6,
    maximumFractionDigits: 6
  })} ${moeda}`;
};

/**
 * Formatar cotação (taxa de câmbio) com formatação apropriada
 */
export const formatExchangeRate = (totalBrl, quantidade, moeda) => {
  if (!totalBrl || !quantidade || isNaN(totalBrl) || isNaN(quantidade) || quantidade === 0) {
    return "N/A";
  }
  
  const rate = parseFloat(totalBrl) / parseFloat(quantidade);
  
  // Para BRL, mostrar como currency simples
  if (moeda === "BRL") {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(rate);
  }
  
  // Para crypto, mostrar R$ por unidade de crypto
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 8
  }).format(rate);
};

/**
 * Validar se todos os campos obrigatórios estão preenchidos
 */
export const validateOperationForm = (cliente, moeda, quantidade, totalBrl, subOperacoes) => {
  const errors = [];

  if (!cliente) {
    errors.push("Por favor, selecione um cliente");
  }

  if (!moeda) {
    errors.push("Por favor, selecione uma moeda");
  }

  if (!quantidade || !totalBrl) {
    errors.push("Por favor, preencha quantidade e total");
  }

  if (subOperacoes.length === 0) {
    errors.push("Por favor, adicione pelo menos uma sub-operação");
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Validar formulário de sub-operação
 */
export const validateSubOperationForm = (fornecedor_nome, quantidade, cotacao) => {
  const errors = [];

  if (!fornecedor_nome) {
    errors.push("Nome do fornecedor é obrigatório");
  }

  if (!quantidade) {
    errors.push("Quantidade é obrigatória");
  }

  if (!cotacao) {
    errors.push("Cotação é obrigatória");
  }

  return {
    isValid: errors.length === 0,
    errors
  };
}; 